import { useQuery } from '@tanstack/react-query';
import { adminFetch } from '@/lib/apiClient';
import type { AdminRoleView } from '../types/admin';

interface RolesEnvelope {
  success: boolean;
  data?: AdminRoleView[] | null;
}

const fetchRoleViews = async (path: string): Promise<AdminRoleView[]> => {
  const res = await adminFetch(path);
  if (!res.ok) throw new Error(`roles fetch failed: ${res.status}`);
  const env = (await res.json()) as RolesEnvelope;
  return env.data ?? [];
};

export const adminRolesQueryKey = ['admin', 'roles'] as const;
export const adminPermissionsQueryKey = ['admin', 'permissions'] as const;

export const useAdminRolesQuery = () =>
  useQuery<AdminRoleView[]>({
    queryKey: adminRolesQueryKey,
    queryFn: () => fetchRoleViews('/admin/v1/roles'),
  });

export const useAdminPermissionsQuery = () =>
  useQuery<AdminRoleView[]>({
    queryKey: adminPermissionsQueryKey,
    queryFn: () => fetchRoleViews('/admin/v1/permissions'),
  });
